import React, { useEffect, useState } from 'react'
import FormView from './FormView'
import { getRequest } from '../../API/IP';
import { useNavigate, useParams } from 'react-router-dom';
import logo from "../../images/IFFFI_LOGO.png";
import logo1 from "../../images/ashok-logo.png";
import logo2 from "../../images/NFDC-Logo.png";
import { Button, Container } from '@mui/material';
const CinemaiView = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();
    const handleRedirect = (tabName) => {
        navigate(`/dashboard/${tabName}`);
    };
    const loadpreData = async () => {
        if (id) {
            try {
                const predata = await getRequest(`cinemai/${id}`, {});
                const loadpredata = predata.data;
                const loaddata = loadpredata?.payload || {};

                // Parse team_members and ai_tools
                try {
                    loaddata.team_members = JSON.parse(loaddata.team_members || "[]");
                } catch {
                    loaddata.team_members = [];
                }
                try {
                    loaddata.ai_tools = JSON.parse(loaddata.ai_tools || "[]");
                } catch {
                    loaddata.ai_tools = [];
                }

                setFormData(loaddata);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    useEffect(() => {
        loadpreData();
    }, []);

    // ✅ Function to print only the form section
    const handlePrint = () => {
        const printContent = document.getElementById('take-print');
        const originalContents = document.body.innerHTML;

        if (printContent) {
            document.body.innerHTML = printContent.innerHTML;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload(); // reload to restore events & React state
        }
    };

    return (
        <div id="cinema-ai-data" className="p-4">
            <div id="take-print">
                <div className="d-flex justify-content-between m-3 align-items-center">
                    <div className="imgLogoview">
                        <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ width: "100%", height: "100%" }}
                            />
                        </a>
                    </div>
                    <div className="imgLogoview">
                        <img
                            src={logo1}
                            alt="Logo"
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                    <div className="imgLogoview">
                        <img
                            src={logo2}
                            alt="Logo"
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                </div>
                <Container>
                    <div className="text-center m-3">
                        <h4>CinemAI Hackathon:</h4>
                        <p>LTIM X IFFI X Waves Bazaar | AI Film Festival &amp; Hackathon 2025</p>
                    </div>
                </Container>
                <FormView formData={formData} showDeclaration={1} />
            </div>


            {/* ✅ Button to take print */}
            <div className="mt-2 text-center">
                <Button variant="outlined" onClick={() => handleRedirect("cinemai-hackathon")}>
                    Dashboard
                </Button> &nbsp;
                <button
                    onClick={handlePrint}
                    className="btn btn-success"
                >
                    🖨️ Print Form
                </button>
            </div>
        </div>
    );
};

export default CinemaiView;
